export default "__VITE_ASSET__C5SpGlR0__"